const config = {
  breakpoint: {
    xsMax: '575',
    smMin: '576',
    smMax: '767',
    mdMin: '768',
    mdMax: '1023',
    lgMin: '1024',
    lgMax: '1769',
    xlMin: '1770'
  }
};

const visaOptions = {
  required: 'Visa required',
  notRequired: 'No visa required'
};

export {
  config,
  visaOptions
}